/**
 * Recovery Phrase (Mnemonic) Functions
 */
import { WORDLIST } from './wordlist.js';
/**
 * Generate a cryptographically secure 12-word access phrase
 */
export function generatePhrase() {
    const words = [];
    const array = new Uint32Array(12);
    crypto.getRandomValues(array);
    for (let i = 0; i < 12; i++) {
        const index = array[i] % 2048;
        const word = WORDLIST[index];
        if (!word)
            throw new Error('Wordlist error');
        words.push(word);
    }
    return words.join(' ');
}
/**
 * Validate a phrase format (basic check)
 */
export function isValidPhrase(phrase) {
    if (!phrase)
        return false;
    const words = phrase.trim().split(/\s+/);
    if (words.length !== 12)
        return false;
    const wordSet = new Set(WORDLIST);
    return words.every((word) => wordSet.has(word.toLowerCase()));
}
// Re-export wordlist for UI autocomplete/validation
export { WORDLIST };
/**
 * Derive a 32-byte seed from the phrase (Deterministic with Salt)
 * Uses PBKDF2-SHA256 with 200k iterations.
 */
export async function phraseToSeed(phrase, saltString = 'sisumail-v2-seed-salt') {
    const enc = new TextEncoder();
    const keyMaterial = await crypto.subtle.importKey('raw', enc.encode(phrase), { name: 'PBKDF2' }, false, ['deriveBits']);
    const salt = enc.encode(saltString);
    const derivedBits = await crypto.subtle.deriveBits({
        name: 'PBKDF2',
        salt: salt,
        iterations: 100000,
        hash: 'SHA-256',
    }, keyMaterial, 256 // 32 bytes
    );
    return new Uint8Array(derivedBits);
}
//# sourceMappingURL=phrase.js.map